import type { CheckoutResource } from '@/api/resources';

/** Receipt slots that mark a treatment or ritual in the reservation. */
export const TREATMENT_SLOTS = ['upsell.treatments', 'upsell.rituals'];

/**
 * Whether the reservation contains a treatment or ritual, based on the receipt slots.
 *
 * The arrival/departure terms point is only relevant for guests with a treatment or ritual, so
 * it is shown conditionally on this. Standalone treatment/ritual upsells carry the slots above;
 * treatments chosen inside an arrangement carry an arrangement slot and are not detected here.
 */
export function checkoutHasTreatmentOrRitual(checkout: CheckoutResource | undefined): boolean {
	return (
		checkout?.meta?.receipt?.persons?.some((person) =>
			person.items?.some((item) => TREATMENT_SLOTS.includes(item.slot)),
		) ?? false
	);
}
